export default "__VITE_ASSET__osV1T664__"